import { createSlice } from "@reduxjs/toolkit";
import { IDropdown } from "../../models/input";
import { fetchIndicators, fetchMinistries, fetchReports, fetchRoles } from "./masterApi";

interface MasterDataState {
    indicators: IDropdown[];
    roles: IDropdown[];
    reports: IDropdown[];
    ministries: any[];
    isLoading: boolean;
    error: any;
}

const initialState: MasterDataState = {
    indicators: [],
    roles: [],
    reports: [],
    ministries: [],
    isLoading: false,
    error: null
}

const masterDataSlice = createSlice({
    name: "masterData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchIndicators.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchIndicators.fulfilled, (state, action) => {
                state.isLoading = false;
                state.indicators = action?.payload?.data || [];
            })
            .addCase(fetchIndicators.rejected, (state, action) => {
                state.error = action.error?.message || 'Something went wrong';
                state.isLoading = false;
            })
            .addCase(fetchRoles.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchRoles.fulfilled, (state, action) => {
                state.isLoading = false;
                state.roles = action?.payload?.data || [];
            })
            .addCase(fetchRoles.rejected, (state, action) => {
                state.error = action.error?.message || 'Something went wrong';
                state.isLoading = false;
            })
            .addCase(fetchReports.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchReports.fulfilled, (state, action) => {
                state.isLoading = false;
                state.reports = action?.payload?.data || [];
            })
            .addCase(fetchReports.rejected, (state, action) => {
                state.error = action.error?.message || 'Something went wrong';
                state.isLoading = false;
            })
            .addCase(fetchMinistries.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchMinistries.fulfilled, (state, action) => {
                state.isLoading = false;
                state.ministries = action?.payload?.data || [];
            })
            .addCase(fetchMinistries.rejected, (state, action) => {
                state.error = action.error?.message || 'Something went wrong';
                state.isLoading = false;
            })
    }
});

export default masterDataSlice.reducer;